export default "__VITE_ASSET__Dy7egeM5__"